export var BinaryTable;
(function (BinaryTable) {
    let Type;
    (function (Type) {
        Type.map = {};
        Type.Application = 10;
        Type.map[Type.Application] = 'アプリ';
        Type.UnityAssetBundle = 60;
        Type.map[Type.UnityAssetBundle] = 'UnityAssetBundle';
    })(Type = BinaryTable.Type || (BinaryTable.Type = {}));
    let PlatformType;
    (function (PlatformType) {
        PlatformType.map = {};
        PlatformType.Android = 10;
        PlatformType.map[PlatformType.Android] = 'Android';
        PlatformType.Gpg = 16; // Google Play Games
        PlatformType.map[PlatformType.Gpg] = 'Google Play Games';
        PlatformType.IOS = 20;
        PlatformType.map[PlatformType.IOS] = 'iOS';
        PlatformType.Dmm = 79;
        PlatformType.map[PlatformType.Dmm] = 'DMM';
    })(PlatformType = BinaryTable.PlatformType || (BinaryTable.PlatformType = {}));
    let Status;
    (function (Status) {
        Status.map = {};
        Status.Empty = 5;
        Status.map[Status.Empty] = 'ファイルなし';
        Status.Building = 8;
        Status.map[Status.Building] = 'ビルド中';
        Status.New = 10;
        Status.map[Status.New] = '処理待ち';
        Status.Uploading = 12;
        Status.map[Status.Uploading] = '処理中';
        Status.Success = 20;
        Status.map[Status.Success] = '完了';
        Status.Error = 90;
        Status.map[Status.Error] = 'エラー';
        Status.BuildError = 92;
        Status.map[Status.BuildError] = 'ビルドエラー';
        Status.Cancel = 96;
        Status.map[Status.Cancel] = 'キャンセル';
        function isProgress(status) {
            switch (status) {
                case Status.New:
                case Status.Uploading:
                    return true;
                default:
                    return false;
            }
        }
        Status.isProgress = isProgress;
    })(Status = BinaryTable.Status || (BinaryTable.Status = {}));
    let AnalysisStatus;
    (function (AnalysisStatus) {
        AnalysisStatus.map = {};
        AnalysisStatus.None = 5;
        AnalysisStatus.map[AnalysisStatus.None] = '不要';
        AnalysisStatus.New = 10;
        AnalysisStatus.map[AnalysisStatus.New] = '処理待ち';
        AnalysisStatus.Started = 12;
        AnalysisStatus.map[AnalysisStatus.Started] = '処理中';
        AnalysisStatus.Success = 20;
        AnalysisStatus.map[AnalysisStatus.Success] = '完了';
        AnalysisStatus.Error = 90;
        AnalysisStatus.map[AnalysisStatus.Error] = 'エラー';
    })(AnalysisStatus = BinaryTable.AnalysisStatus || (BinaryTable.AnalysisStatus = {}));
    let ConvertStatus;
    (function (ConvertStatus) {
        ConvertStatus.map = {};
        ConvertStatus.None = 5;
        ConvertStatus.map[ConvertStatus.None] = '不要';
        ConvertStatus.New = 10;
        ConvertStatus.map[ConvertStatus.New] = '処理待ち';
        ConvertStatus.Converting = 12;
        ConvertStatus.map[ConvertStatus.Converting] = '処理中';
        ConvertStatus.Success = 20;
        ConvertStatus.map[ConvertStatus.Success] = '完了';
        ConvertStatus.Error = 90;
        ConvertStatus.map[ConvertStatus.Error] = 'エラー';
    })(ConvertStatus = BinaryTable.ConvertStatus || (BinaryTable.ConvertStatus = {}));
    let AutoDeleteType;
    (function (AutoDeleteType) {
        AutoDeleteType.map = {};
        AutoDeleteType.Temp = 5;
        AutoDeleteType.map[AutoDeleteType.Temp] = '一時';
        AutoDeleteType.Normal = 10;
        AutoDeleteType.map[AutoDeleteType.Normal] = '通常';
        AutoDeleteType.KeepForever = 90;
        AutoDeleteType.map[AutoDeleteType.KeepForever] = '最重要';
        function getDescription(type, doAddId = false) {
            let firstText = '';
            let lastText = '';
            switch (Number(type)) {
                case AutoDeleteType.Normal:
                    firstText = '通常　';
                    lastText = '最新更新のバイナリから100件以降かつ、2ヶ月経っている場合、削除されます。';
                    break;
                case AutoDeleteType.Temp:
                    firstText = '一時　';
                    lastText = '最新更新のバイナリから100件以降かつ、2週間経っている場合、削除されます。';
                    break;
                case AutoDeleteType.KeepForever:
                    firstText = '最重要';
                    lastText = '削除されません。';
                    break;
            }
            if (doAddId) {
                firstText += `(${type})`;
            }
            const description = `${firstText}:  ${lastText}`;
            console.log(description);
            return description;
        }
        AutoDeleteType.getDescription = getDescription;
    })(AutoDeleteType = BinaryTable.AutoDeleteType || (BinaryTable.AutoDeleteType = {}));
})(BinaryTable || (BinaryTable = {}));
